import React, { useState } from 'react';
import {
  Button, Grid, TextField, Typography, CircularProgress, makeStyles,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userSignIn } from '../../redux/actions/authActions';
import {
  configureAxios, BASE_URL, TENANT_DOMAIN, DEFAULT_BACK_PATHNAME,
} from '../../config';
import { setToken, authenticate } from '../../core/services/authService';
import logo from '../../assets/images/ryffine_big_logo.png';
import { getCookie } from '../../core/services/cookieService';
import { BACK_PATHNAME_COOKIE_NAME } from '../../core/constants';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
  },
  header: {
    backgroundColor: '#1C355E',
    padding: theme.spacing(2.5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    padding: theme.spacing(4),
  },
  logo: {
    maxWidth: '200px',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    display: 'block',
  },
}));

const Login = () => {
  const classes = useStyles();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogin = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const authResponse = await authenticate(BASE_URL, TENANT_DOMAIN, username, password);
      setLoading(false);

      if (!('errorMessage' in authResponse)) {
        setToken(authResponse.token, authResponse.expiresIn, authResponse.refreshToken);
        configureAxios();

        dispatch(userSignIn({ isSignedIn: true }));

        let backPathname = getCookie(BACK_PATHNAME_COOKIE_NAME) || '/';
        if (backPathname === '' || backPathname === '/') {
          if (DEFAULT_BACK_PATHNAME) backPathname = DEFAULT_BACK_PATHNAME;
        }

        history.push(backPathname);
      } else {
        setError(authResponse.errorMessage || 'Invalid username or password.');
      }
    } catch (err) {
      setLoading(false);
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <Grid container className="df-center p-5">
      <Grid item xs={10} sm={6} md={4} className={classes.root}>
        <Grid container direction="column">
          <Grid item xs={12} className={classes.header}>
            <img src={logo} alt="Logo" className={classes.logo} />
          </Grid>
          <Grid item xs={12} className={classes.content}>
            <Grid container direction="column" spacing={3}>
              <Grid item className="df-center">
                <Typography variant="h5" align="center" className="m-0">
                  Sign in with your username and password
                </Typography>
              </Grid>
              {error && (
                <Grid item className="df-center">
                  <Typography color="error" align="center">
                    {error}
                  </Typography>
                </Grid>
              )}
              <Grid item>
                <TextField
                  label="Username"
                  variant="outlined"
                  fullWidth
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  required
                />
              </Grid>
              <Grid item>
                <TextField
                  label="Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </Grid>
              <Grid item className="df-center">
                <Button
                  disabled={!username || !password || loading}
                  style={{ minWidth: '110px' }}
                  className="m-2 button"
                  onClick={handleLogin}
                  variant="contained"
                  color="primary"
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
                </Button>
              </Grid>
              <Grid item className="df-center">
                <Typography variant="body2" align="center">
                  Forgot your password?
                  {' '}
                  <a href="/forgot-password">Click here</a>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Login;
